import ParticleEmitter from "../Animations/ParticleEmitter";
import * as PIXI from "pixi.js-legacy";

export class Frames {

    static counter: number = 0;
    /*
     *  SYMBOLS
     */
    static symbol_J: Array<PIXI.Texture> = []; //PIXI.AnimatedSprite;
    static symbol_Q: Array<PIXI.Texture> = []; //PIXI.AnimatedSprite;
    static symbol_K: Array<PIXI.Texture> = []; //PIXI.AnimatedSprite;
    static symbol_A: Array<PIXI.Texture> = []; //PIXI.AnimatedSprite;

    static symbol_Wild: Array<PIXI.Texture> = []; //PIXI.AnimatedSprite;
    static symbol_Scatter: Array<PIXI.Texture> = []; //PIXI.AnimatedSprite;
    static symbol_Woman: Array<PIXI.Texture> = []; //PIXI.AnimatedSprite;
    static symbol_Viking: Array<PIXI.Texture> = []; //PIXI.AnimatedSprite;

    static symbol_Bracelet: Array<PIXI.Texture> = []; //PIXI.AnimatedSprite;
    static symbol_Helmet: Array<PIXI.Texture> = []; //PIXI.AnimatedSprite;
    static symbol_Shield: Array<PIXI.Texture> = []; //PIXI.AnimatedSprite;
    static symbol_Axe: Array<PIXI.Texture> = []; //PIXI.AnimatedSprite;

    /*
     *  EFFECTS
     */
    static dust: Array<PIXI.Texture> = [];
    static lightning: Array<PIXI.Texture> = [];
    static sea: Array<PIXI.Texture> = [];
    static clouds: Array<PIXI.Texture> = [];

    static ropeFire: Array<PIXI.Texture> = [];
    static textFire: Array<PIXI.Texture> = [];
    static screenFire: Array<PIXI.Texture> = [];
    static wildBGFire: Array<PIXI.Texture> = [];

    static arrowFire: Array<PIXI.Texture> = [];
    static fireRing : Array<PIXI.Texture> = [];

    /*
     *  BIG WIN
     */
    static bigWinFire:  Array<PIXI.Texture> = [];
    
    constructor() {}

    /**
     * CREATES ARRAY OF TEXTURES , FOR ANIMATION,
     * @param {string} str = name of the image set 
     * ( example > if you have images of animation named "symbol_J_00000", "symbol_J_00001", "symbol_J_00002"  then
     *   "symbol_J_000" is the name of the image sete + the last numbers are added to the string name by the function ,
     *   !!!!  BUT only till 99 , !!!! that is if the last sprite for animation is more then 99 ->
     *   !!!!  if the number of the animation sprites (from TexturePacker) is more then 99  "symbol_J_012345", for that specific animation 
     *   !!!!  then this function needs to be edited ),
     * @param {number} n = the number of the last image (example > symbol_J_00059.png => n = 59) , in function it adds +1 to be able to loop threw all the images
     * @param {boolean} b = boolean , if the image names are in JSON file/atlas named with ".png" extension or not ( DEFAULT IS "TRUE" ) -> 
     *                      "symbol_J_00000", "symbol_J_00001", "symbol_J_00002" <widthout extension ,  with extension > "symbol_J_00000.png", "symbol_J_00001.png", "symbol_J_00002.png"
     * @param {number} firstImageNumber = if the animation atlas pictures doesn't start with 0 ( symbol_J_00001.png <- is the first picture in the atlas) ( DEFAULT IS 0)
     * @returns {Array<PIXI.Texture>}
     */
    static toTextureArray(        
        str: string,
        n: number,
        b: boolean = true,
        firstImageNumber: number = 0
    ) {
        
        Frames.counter++;
        let textureArray = [];
        ++n;

        for (let i = firstImageNumber; i < n; i++) {
            let s = '0' + i;
            if (i > 9) {
                s = i.toString();
            }
            if (b) {
                s += '.png';
            }

            //let texture = PIXI.utils.TextureCache[str+s];
            let texture = PIXI.Texture.from(str + s);
            textureArray.push(texture);
        }
        return textureArray;
        //return new PIXI.AnimatedSprite(textureArray);
    }

    static init() {
        ParticleEmitter.fillParticleTextureList();

        Frames.symbol_J = this.toTextureArray('symbol_J_000', 29);
        Frames.symbol_Q = this.toTextureArray('symbol_Q_000', 29);
        Frames.symbol_K = this.toTextureArray('symbol_K_000', 29);
        Frames.symbol_A = this.toTextureArray('symbol_A_000', 29);

        Frames.symbol_Wild = this.toTextureArray('symbol_Wild_000', 29,false);
        Frames.symbol_Scatter = this.toTextureArray('symbol_Scatter_000', 29);
        this.symbol_Woman = this.toTextureArray('symbol_Woman_000', 29);
        this.symbol_Viking = this.toTextureArray('symbol_Viking_000', 29);

        this.symbol_Bracelet = this.toTextureArray('symbol_Bracelet_000', 29);        
        Frames.symbol_Helmet = this.toTextureArray('symbol_Helmet_000', 29);        
        this.symbol_Shield = this.toTextureArray('symbol_Shield_000', 29);
        this.symbol_Axe = this.toTextureArray('symbol_Axe_000', 29);

        this.dust = this.toTextureArray('dust_000', 37,true, 1);
        this.lightning = this.toTextureArray('storm_', 5);
        this.sea = this.toTextureArray("sea_reels_menu_000", 26, false);
        this.clouds = this.toTextureArray("cloud_",3, false, 1);

        this.ropeFire = this.toTextureArray("fire-rope_000", 14, false);
        this.textFire = this.toTextureArray("fire_free-spins_000", 17, false);
        this.screenFire = this.toTextureArray("fire_free-spins_background_000", 15,false);
        this.wildBGFire = this.toTextureArray("fire_background_000", 19, false);

        this.arrowFire = this.toTextureArray("fire_000", 9, false);
        this.fireRing = this.toTextureArray("fire_ring_000", 54, false);

        this.bigWinFire = this.toTextureArray("bigWinFire_000", 23, false, 1);
    }
}